var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-lg-5 col-xl-6"},[_c('tablegutters')],1),_c('div',{staticClass:"col-md-8 col-lg-7 col-xl-6"},[_c('formestgutter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }